
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router';

//import service
import pservice from '@/core/services/PublicService';

export default defineComponent({
    name: "public-manager-sport",
    setup() {
        const route = useRoute();
        const { idevent, idsport } = route.params
        const evento = ref<any>({})
        const sport  = ref<any>({})
        const botones = ref<any>({})
        const link1 = ref<any>(null)
        const link2 = ref<any>(null)

        const getDetails = async () => {
            await pservice.more({
                evento: idevent,
                sport: idsport
            }).then((res) => {
                    evento.value = res.data.event
                    sport.value = res.data.sport

                    getBotones();
                }).catch(({ response }) => { })
        }

        const getBotones = async () => {
            await pservice.getBotones(`idevent=${evento.value.idevent}&idsport=${sport.value.idsport}`).then((res) => {
                botones.value = res.data

                link1.value = `https://winscore.perufedup.com/publico/campeonatos/${evento.value.idevent}/categorias/${sport.value.idsport}/posiciones`;
                link2.value = `https://winscore.perufedup.com/publico/campeonatos/${evento.value.idevent}/categorias/${sport.value.idsport}/llaves`


                }).catch(({ response }) => { })
        }

        //const getSports

        onMounted(() => {
            getDetails()
        })

        return {
            idevent,
            idsport,
            evento,
            sport,
            botones,
            link1, link2,
            getDetails
        }
        
    },
})
